const CompanyPermission = {

    // FIELDS
    "company": "Company",
    "permission": "Permission",

    // PAGE HEADER
    "company_permission": "Company Permission",

    // ERROR
    "error_company": "Select Company",
    "error_permission": "Select Permission",

}

export default CompanyPermission;